import React, { Component, ErrorInfo, ReactNode } from 'react';

import { ErrorScreen } from 'components/Info';

interface IErrorBoundary {
	children: ReactNode;
}

interface IErrorBoundaryState {
	hasError: boolean;
}

// Catches render errors anywhere below it and shows an error screen with a reload option
// instead of a blank page.
export class ErrorBoundary extends Component<IErrorBoundary, IErrorBoundaryState> {
	state: IErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError(): IErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('ErrorBoundary', error, errorInfo.componentStack);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex flex-col w-full min-h-screen bg-black">
					<ErrorScreen />
				</div>
			);
		}

		return this.props.children;
	}
}
